var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 475.078,
    height: 438.536,
    viewBox: "0 0 475.078 438.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-to-storage-drive",
    transform: "translate(0 -18.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4194",
    "data-name": "Path 4194",
    d: "M467.083,318.627a26.424,26.424,0,0,0-19.41-7.994H315.2L276.367,349.46q-16.56,15.986-38.828,15.988T198.711,349.46l-38.543-38.827H27.408a26.453,26.453,0,0,0-19.414,7.994A26.427,26.427,0,0,0,0,338.044V429.4a26.427,26.427,0,0,0,7.994,19.414,26.434,26.434,0,0,0,19.414,7.99H447.674a27.287,27.287,0,0,0,27.4-27.4V338.044A26.417,26.417,0,0,0,467.083,318.627ZM360.025,414.841A17.93,17.93,0,1,1,365.446,402,17.578,17.578,0,0,1,360.025,414.841Zm73.084,0A17.916,17.916,0,1,1,438.536,402,17.552,17.552,0,0,1,433.109,414.841Z",
    fill: "#00a8f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4195",
    "data-name": "Path 4195",
    d: "M224.692,323.479a17.933,17.933,0,0,0,25.694,0L378.293,195.571q8.848-8.278,4-19.986-4.845-11.132-16.844-11.136H292.355V36.543A17.58,17.58,0,0,0,286.934,23.7a17.568,17.568,0,0,0-12.847-5.426h-73.1A17.565,17.565,0,0,0,188.144,23.7a17.562,17.562,0,0,0-5.424,12.847V164.45H109.631q-12,0-16.846,11.136-4.851,11.7,4,19.986Z",
    fill: "#00a8f1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.24b68c14c2388bd003e908c675dcbb8b.svg";
export { ForwardRef as ReactComponent };